/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Purchase_Order_Not_Ready_For_ConfirmationInputs */

const en_error_purchase_order_not_ready_for_confirmation = /** @type {(inputs: Error_Purchase_Order_Not_Ready_For_ConfirmationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The purchase order cannot be confirmed yet.`)
};

/**
* | output |
* | --- |
* | "The purchase order cannot be confirmed yet." |
*
* @param {Error_Purchase_Order_Not_Ready_For_ConfirmationInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_purchase_order_not_ready_for_confirmation = /** @type {((inputs?: Error_Purchase_Order_Not_Ready_For_ConfirmationInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Purchase_Order_Not_Ready_For_ConfirmationInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_purchase_order_not_ready_for_confirmation(inputs)
});